import VisibilitySensor from 'react-visibility-sensor';
import VisibleAd from './VisibleAd';
import { AdProps } from '.';

const DEBOUNCE_TIME = 250;
const PROXIMITY_TOLERANCE = 400;

export default function ProximityAd(props: AdProps): JSX.Element {
  return (
    <VisibilitySensor
      scrollDelay={DEBOUNCE_TIME}
      offset={{ bottom: -PROXIMITY_TOLERANCE }}
      partialVisibility={true}
    >
      {({ isVisible }: { isVisible: boolean }): JSX.Element => {
        return <VisibleAd isVisible={isVisible} {...props} />;
      }}
    </VisibilitySensor>
  );
}
